import { client } from "./client";

export const fetchEvents = async () => {
    const response = await client.get("/api/events/", { _skipAuth: true });
    return response.data;
};

export const fetchEventDetail = async (id) => {
    const response = await client.get(`/api/events/${id}/`, { _skipAuth: true });
    return response.data;
};
